import * as React from 'react'
import * as SeparatorPrimitive from '@radix-ui/react-separator'

import { Separator as OriginSeparator } from '../ui/separator'

import { cn } from '../../lib/utils'

function Separator({
  className,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <OriginSeparator
      className={cn('bg-lines-and-borders', className)}
      {...props}
    />
  )
}

export { Separator }
